import { render, staticRenderFns } from "./ProjectGeneralInfo.vue?vue&type=template&id=7c83d324&scoped=true"
import script from "./ProjectGeneralInfo.vue?vue&type=script&lang=ts"
export * from "./ProjectGeneralInfo.vue?vue&type=script&lang=ts"
import style0 from "./ProjectGeneralInfo.vue?vue&type=style&index=0&id=7c83d324&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c83d324",
  null
  
)

export default component.exports